import { IEditor } from 'roosterjs-editor-types';
import { CID_PREFIX } from './constants';

export default function getImageElementsByContentId(
    editor: IEditor,
    contentId: string
): HTMLImageElement[] {
    return editor.queryElements<HTMLImageElement>(`img[originalsrc^="${CID_PREFIX + contentId}"]`);
}
